module.exports = __webpack_public_path__ + "static/17.2_Renaissance-d33edbc8dc27e1d8e381204eab7d3e21.pdf";